// src/jira/issue-field-option/types.ts
var JiraIssueFieldOptionAriResourceOwner = "jira", JiraIssueFieldOptionAriResourceType = "issue-field-option";

export {
  JiraIssueFieldOptionAriResourceOwner,
  JiraIssueFieldOptionAriResourceType
};
